import { scholarshipActionTypes } from 'src/store/actions';

const initialState = {};

const VerifyStudentScholarshipReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case scholarshipActionTypes.GET_STUDENT_SCHOLARSHIP_LIST:
      return { ...state, ...payload };
    default:
      return state;
  }
};

export default VerifyStudentScholarshipReducer;
